<template>
  <div id="special-plus">
    <div
      class="grid-left"
      v-for="(matchId, index) in matchIds"
      :key="matchId">
      <match
        :id-match="matchId"
        :colored-id="index % 2 === 1"
      />
    </div>
  </div>
</template>

<script>
import { each } from 'lodash';
import Match from './Match.vue';

export default {
  name: 'SpecialPlus',
  components: {
    Match,
  },
  computed: {
    matchIds() {
      const matches = [];
      const sports = this.$store.getters.activeSports;

      // Stream matches
      let loop = true;
      each(sports, (sport) => {
        if (!loop) return;

        const sportMatches = this.$store.getters.getStreamMatchIds(sport.id);
        each(sportMatches, (sportMatch) => {
          if (!loop) return;

          matches.push(sportMatch);
          if (matches.length > 1) loop = false;
        });
      });

      // Scout matches
      if (matches.length < 2) {
        each(sports, (sport) => {
          if (!loop) return;

          const sportMatches = this.$store.getters.getScoutMatchIds(sport.id);
          each(sportMatches, (sportMatch) => {
            if (!loop) return;

            // Check if match alreay exists
            if (matches.indexOf(sportMatch) === -1) {
              matches.push(sportMatch);
            }

            if (matches.length > 1) loop = false;
          });
        });
      }

      return matches;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

#special-plus {
  float: left;
  width: 100%;
}

.grid-left {
  float: left;
  width: 50%;

  &:first-child {
    border-right: 2px solid $color-border;
  }
  &:nth-child(2) {
    border-left: 2px solid $color-border;
  }
}
</style>
